export function computeTestLabel(index, count, includesControl = true) {
  if(index === count - 1) {
    var labels = []

    _.times(count - 1, (index) => {
      if(!includesControl) {
        labels.push(getTestLabel(index + 1))
      } else if(includesControl && index > 0) {
        labels.push(getTestLabel(index))
      }
    })

    return labels.join(' + ')
  } else {
    if(!includesControl) {
      return getTestLabel(index + 1)
    } else {
      return getTestLabel(index)
    }
  }
}

export function getTestLabel(index) {
  if(index === 0) {
    return 'KONTROL'
  } else if(index - 1 < 26) {
    return String.fromCharCode(index - 1 + 65)
  } else {
    return 'Z' + (index - 1 - 25)
  }
}

export function sortTests(tests) {
  return tests.sort((a, b) => {
    if(a.id < b.id || a.is_control) {
      return -1
    } else if(a.id > b.id || b.is_combined) {
      return 1
    } else {
      return 0
    }
  })
}